import { render, staticRenderFns } from "./scheduling-days.vue?vue&type=template&id=cab05130&scoped=true&lang=pug&"
import script from "./scheduling-days.vue?vue&type=script&lang=ts&"
export * from "./scheduling-days.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab05130",
  null
  
)

export default component.exports